import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../core/services/auth.guard';
import { ResetTSService, TestSpaceServiceLoadResolver } from '../modules/drawout-test-space/shared/route-managers/test-space-service-data-managers';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { CommonLayoutComponent } from './common-layout/common-layout.component';
import { HomePageComponent } from './home-page/home-page.component';
import { InnactiveOrganisationComponent } from './innactive-organisation/innactive-organisation.component';
import { InnactiveUserComponent } from './innactive-user/innactive-user.component';
import { LicenseErrorComponent } from './license-error/license-error.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RegisterComponent } from './register/register.component';
import { AddOrganisationComponent } from './home-page/add-organisation/add-organisation.component';
import { RegistrationComponent } from './registration/registration.component';
import { NewOrganisationComponent } from './new-organisation/new-organisation.component';
import { LoginGuard } from '../core/services/login.guard';
import { organisationAdminGuard } from '../core/services/organisation-admin.guard';
import { PurchaseNewProductComponent } from './home-page/purchase-new-product/purchase-new-product.component';

const routes: Routes = [
    {
        path: 'register',
        component: RegisterComponent
    },
    {
        path: 'registration',
        canActivate: [LoginGuard],
        component: RegistrationComponent,
    },
    {
        path: '',
        component: CommonLayoutComponent,
        children: [
            {
                path: 'home',
                canActivate: [AuthGuard],
                component: HomePageComponent,

            },
            {
                path: 'purchase-product',
                canActivate: [AuthGuard],
                component: PurchaseNewProductComponent
            },
            {
                path: 'add-organisation',
                canActivate: [AuthGuard],
                component: NewOrganisationComponent
            },
            {
                path: 'settings',
                canActivate: [organisationAdminGuard],
                loadChildren: () => import('../modules/settings/settings.module').then(mod => mod.SettingsModule)
            },
            {
                path: 'workspaces',
                canActivate: [AuthGuard],
                loadChildren: () => import('../modules/drawout-app-pro/drawout-app-pro.module').then(mod => mod.DrawoutAppProModule)
            },
            {
                path: 'drawout-app',
                canActivate: [AuthGuard],
                loadChildren: () => import('../modules/drawout-app/drawout-app.module').then(mod => mod.DrawoutAppModule)
            },
            {
                path: 'sketch',
                canActivate: [AuthGuard],
                loadChildren: () => import('../modules/drawout-lite/drawout-lite.module').then(mod => mod.DrawoutLiteModule)
            },
            {
                path: 'drawout-test-spaces',
                canActivate: [AuthGuard],
                loadChildren: () => import('../modules/drawout-test-space/drawout-test-space.module').then(mod => mod.DrawoutTestSpaceModule),
                resolve: { tsServiceLoaded: TestSpaceServiceLoadResolver },
                canDeactivate: [ResetTSService]
            },
            {
                path: 'license-error',
                component: LicenseErrorComponent
            },
            {
                path: 'unauthorized',
                component: AccessDeniedComponent
            },
            {
                path: 'innactive-organisation',
                component: InnactiveOrganisationComponent
            },
            {
                path: 'innactive-user',
                component: InnactiveUserComponent
            },
            {
                path: '404',
                component: NotFoundComponent
            },
            { path: '**', redirectTo: '/404' }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DOLayoutRoutingModule { }
